import { Component } from '@angular/core';
import { of } from 'rxjs';
import { catchError, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { StreakerCentralStateService } from '../services/streaker-central-state.service';
import { OverallActivityTotals, OverallStatsService } from '../services/overall-stats.service';

@Component({selector: 'app-central-overall-stats', templateUrl: './central-overall-stats.component.html', styleUrls: ['./central-overall-stats.component.scss']})
export class CentralOverallStatsComponent {
    readonly view$ = this.state.state$.pipe(map(s=>({id:s.challenge?.ChallengeDefinitionId || 0,user:s.userId,name:s.challenge?.Name || '',loading:s.loading})),
        distinctUntilChanged((a,b)=>JSON.stringify(a)===JSON.stringify(b)),switchMap(context=>{
            const empty={name:context.name,loading:false,error:'',totals:{} as OverallActivityTotals};
            if(!context.id || context.loading) return of({...empty,loading:context.loading});
            return this.stats.loadChallengeTotals(context.id).pipe(map(totals=>({...empty,totals})),
                catchError(()=>of({...empty,error:'Unable to load activity totals. Please try again.'})),startWith({...empty,loading:true}));
        }));
    constructor(public state:StreakerCentralStateService,private stats:OverallStatsService){}
}
